export const blogPosts = [
  {
    slug: "ai-edu-tech-curriculum",
    title: "AI & Tech Curriculum: Empowering Tomorrow's Innovators",
    date: "July 2024",
    author: "HexaPi Tech Team",
    excerpt:
      "Introducing our hands-on AI, coding and robotics curriculum for Grades 1-10. Develop 21st-century STEM skills in every classroom.",
    image: "/images/portfolio/ai lab.png",
    content: `
## Empowering Tomorrow's Innovators

At HexaPi Tech, we believe that to us, you're not a client — but a partner in shaping the next generation of engineers, empowering them to raise Lebanon's flag to the skies.

We are proud to announce our comprehensive **AI & Tech Curriculum** — a hands-on program covering AI, coding, and robotics for Grades 1-10, designed to develop 21st-century STEM skills in every classroom.

## 21st Century Tech Education

Today's world is changing rapidly and so are the skills required by everyone to advance. In this curriculum, we cover most of the future-ready skills like:

### Computer Skills
- Microsoft Office Suite (PowerPoint, Word, Excel)
- Essential digital literacy

### Design Skills
- Canva and graphic design tools
- Creative digital expression

### Programming Skills
- HTML, Python, and AI fundamentals
- In-depth AI for classes 9 & 10, preparing students for college

In addition to **Entrepreneurial** and **Project Management** skills.

## What Do We Offer?

### Structured Curriculum
Our curriculum and textbooks are designed with a grade-wise syllabus for 1st to 10th with hands-on activities. No other computer textbook is needed — it's an all-in-one package!

### AI and Robotics Kit
Equip your school with a Next-Gen AI laboratory along with the best AI-learning kits.

### Coding and AI Platform
Every student gets a license to a coding platform in order to build AI projects and apply activities.

### Teacher Resources
Teachers gain access to a comprehensive Learning Management System with all the teaching materials.

### Teacher Training
We conduct teacher upskilling sessions to train your computer science teachers.

### Certificates & Competitions
- Exclusive access to national and international competitions
- Online certificates for students

## It's Not Just an AI Lab, It's a Skilling Program

Our curriculum goes beyond traditional teaching methods to provide practical, hands-on experience that prepares students for the future.

## What Our Clients Say

"Our students are now coding, building robots, and exploring AI — all before high school!"

— Mr. Alaa M., Principal, LMC Hasbaya

## How Easy Is It to Integrate This Curriculum?

We take care of all kits, books, and add-ons in addition to training your teachers. All you have to do is prepare a lab inside your school with internet access.

**We offer a 1-year warranty that covers all the kits.**

## Ready to Lead in Tech Education?

Partner with HexaPi Tech and give your school a cutting-edge STEM curriculum. We handle hardware, training, and certification — you enjoy engaged students and a reputation for innovation.

## Elevate Your Institution's Reputation

Contact us today to get started and transform your school into a hub of technological innovation.
    `,
  },
];

export const getBlogPostBySlug = (slug) => {
  return blogPosts.find((post) => post.slug === slug);
};
